export type Experiment = {
    activateOnPageLoad: boolean;
    name: string;
    variations: {
        [key: string]: string;
    };
};

export const ListOverview: Experiment = {
    activateOnPageLoad: true,
    name: 'list_overview',
    variations: {
        Off: 'off',
        On: 'on',
    },
};

export const experiments: Experiment[] = [ListOverview];
